/* unplugin-vue-components disabled */import script from "./ChatReply.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatReply.vue?vue&type=script&setup=true&lang=js"

import "./ChatReply.vue?vue&type=style&index=0&id=3ead9cd3&lang=stylus"

const __exports__ = script;

export default __exports__